import { DoqFaceSvgProps } from '../types';

const keyframes = `
@keyframes doqy-choose-org-animation-0 {
  0% {
    transform: translate(0px,0px);
    animation-timing-function: cubic-bezier(0,0.875349,0,0.98601);
  }
  33.3333% {
    transform: translate(0px,0px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  50% {
    transform: translate(9px,-5px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  66.6666% {
    transform: translate(9px,0px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  83.3333% {
    transform: translate(9px,3px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  100% {
    transform: translate(0px,0px);
  }
}
@keyframes doqy-choose-org-animation-1 {
  0% {
    transform: translate(0px,0px);
    animation-timing-function: cubic-bezier(0,0.875349,0,0.98601);
  }
  33.3333% {
    transform: translate(0px,0px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  50% {
    transform: translate(3px,-5px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  66.6666% {
    transform: translate(3px,0px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  83.3333% {
    transform: translate(3px,3px);
    animation-timing-function: cubic-bezier(0,1,0,1);
  }
  100% {
    transform: translate(0px,0px);
  }
}
`;

const ChooseOrg = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    role="presentation"
  >
    <style>{keyframes}</style>
    <g clipPath="url(#clip0_1409_41860)">
      <g clipPath="url(#clip1_1409_41860)">
        {/* mask to hide the bottom outline of the circle */}
        <mask id="bottom-mask-choose-org">
          <circle cx="160" cy="160" r="160" fill="white" />
          <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
        </mask>
        <circle
          cx="160"
          cy="160"
          r="160"
          fill="#FCBF4C"
          mask="url(#bottom-mask-choose-org)"
        />

        <mask
          id="mask0_1409_41860"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="320"
          height="320"
        >
          <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
        </mask>
        <g mask="url(#mask0_1409_41860)">
          <rect x="80" y="120" width="160" height="200" fill="white" />
        </g>

        <g opacity="0.5">
          {/* First horizontal line of doqy */}
          <path
            d="M96 243C96 242.448 96.4477 242 97 242H223C223.552 242 224 242.448 224 243V245C224 245.552 223.552 246 223 246H97C96.4477 246 96 245.552 96 245V243Z"
            fill="#2974C4"
          />

          {/* Third horizontal line */}
          <path
            d="M96 277C96 276.448 96.4477 276 97 276H223C223.552 276 224 276.448 224 277V279C224 279.552 223.552 280 223 280H97C96.4477 280 96 279.552 96 279V277Z"
            fill="#2974C4"
          />

          {/* Second horizontal line */}
          <path
            d="M97 258C96.4477 258 96 258.448 96 259V261C96 261.552 96.4477 262 97 262H223C223.552 262 224 261.552 224 261V259C224 258.448 223.552 258 223 258H97Z"
            fill="#2974C4"
          />

          {/* Fourth horizontal line */}
          <path
            d="M96 293C96 292.448 96.4477 292 97 292H223C223.552 292 224 292.448 224 293V295C224 295.552 223.552 296 223 296H97C96.4477 296 96 295.552 96 295V293Z"
            fill="#2974C4"
          />
        </g>

        {/* Right eye of Doqy */}
        <path
          d="M186,176C186,180.418,182.418,184,178,184C173.582,184,170,180.418,170,176C170,171.582,173.582,168,178,168C182.418,168,186,171.582,186,176Z"
          fill="#2974C4"
          transform="translate(178,176) translate(-178,-176)"
          style={{
            animation: '12s linear infinite both doqy-choose-org-animation-0',
          }}
        />

        {/* left eye of Doqy */}
        <path
          d="M150,176C150,180.418,146.418,184,142,184C137.582,184,134,180.418,134,176C134,171.582,137.582,168,142,168C146.418,168,150,171.582,150,176Z"
          fill="#2974C4"
          transform="translate(142,176) translate(-142,-176)"
          style={{
            animation: '12s linear infinite both doqy-choose-org-animation-1',
          }}
        />

        {/* Glasses on Doqy's face */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.969 177C154.453 185.371 147.501 192 139 192C130.163 192 123 184.837 123 176C123 167.163 130.163 160 139 160C147.159 160 153.892 166.107 154.876 174H165.124C166.108 166.107 172.841 160 181 160C189.837 160 197 167.163 197 176C197 184.837 189.837 192 181 192C172.499 192 165.547 185.371 165.031 177H154.969ZM152 176C152 183.18 146.18 189 139 189C131.82 189 126 183.18 126 176C126 168.82 131.82 163 139 163C146.18 163 152 168.82 152 176ZM181 189C188.18 189 194 183.18 194 176C194 168.82 188.18 163 181 163C173.82 163 168 168.82 168 176C168 183.18 173.82 189 181 189Z"
          fill="#2974C4"
        />

        {/* Circular top of Doqy's cap */}
        <circle cx="160.014" cy="70.0236" r="6.41723" fill="#418B82" />

        {/* Cap of Doqy */}
        <path
          d="M74.4512 140.332C74.4512 100.974 112.834 68.954 160.014 68.954C207.194 68.954 245.577 100.974 245.577 140.332V157.726L207.13 150.353C176.119 144.442 143.909 144.442 112.898 150.353L74.4512 157.726V140.332Z"
          fill="#500052"
        />

        {/* Green cap outline below */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.8657 167.531L76.8643 167.532C73.8738 168.8 70.4217 167.404 69.1532 164.413C67.8845 161.422 69.2805 157.969 72.2714 156.701L74.5685 162.116C72.2714 156.701 72.2738 156.7 72.2738 156.7L72.3178 156.681L72.4259 156.636C72.5184 156.597 72.6514 156.542 72.8236 156.471C73.1681 156.33 73.6695 156.126 74.3175 155.87C75.6133 155.357 77.4963 154.631 79.883 153.763C84.6538 152.028 91.4505 149.722 99.6023 147.417C115.848 142.823 137.737 138.156 159.799 138.156C181.861 138.156 203.75 142.823 219.996 147.417C228.147 149.722 234.944 152.028 239.715 153.763C242.102 154.631 243.985 155.357 245.281 155.87C245.929 156.126 246.43 156.33 246.774 156.471C246.947 156.542 247.08 156.597 247.172 156.636L247.28 156.681L247.311 156.694L247.324 156.7C247.324 156.7 247.327 156.701 245.029 162.116L247.327 156.701C250.317 157.969 251.714 161.422 250.445 164.413C249.176 167.403 245.724 168.8 242.734 167.532L242.732 167.531L242.717 167.525L242.64 167.493C242.568 167.463 242.457 167.417 242.307 167.355C242.006 167.231 241.55 167.046 240.95 166.809C239.749 166.333 237.969 165.647 235.695 164.82C231.144 163.165 224.623 160.952 216.794 158.738C201.078 154.294 180.352 149.921 159.799 149.921C139.246 149.921 118.52 154.294 102.804 158.738C94.9749 160.952 88.4544 163.165 83.9031 164.82C81.6287 165.647 79.8495 166.333 78.6483 166.809C78.0478 167.046 77.5921 167.231 77.2914 167.355C77.1411 167.417 77.0296 167.463 76.9583 167.493L76.8814 167.525L76.8657 167.531Z"
          fill="#6DBCB4"
        />

        {/* Ardoq brand icon */}
        <path
          d="M157.352 95.5201H150.12V102.752H157.352V95.5201Z"
          fill="white"
        />
        <path
          d="M171.817 109.986H150.12V117.218H171.817V109.986Z"
          fill="white"
        />

        {/* Mouth of doqy */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M161.851 207.995C160.816 207.918 160 207.054 160 206C160 204.895 160.895 204 162 204H176.5C178.433 204 180 202.433 180 200.5C180 200.33 179.988 200.163 179.964 199.999L180 199.999C180.001 198.895 180.896 198 182 198C183.105 198 184 198.895 184 200C184 200.058 183.997 200.116 183.993 200.174L183.984 199.999C183.994 200.165 184 200.332 184 200.5C184 204.642 180.642 208 176.5 208H162L161.851 207.995Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1409_41860">
        <rect width="320" height="320" fill="white" />
      </clipPath>
      <clipPath id="clip1_1409_41860">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { ChooseOrg };
